export default "__VITE_ASSET__a4bf43b5__"